import React from 'react';
import { Button } from 'react-covideo-common';
import { MdDone } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import {
  ActiveHeader,
  ActiveOptionContainer,
  AddonFooter,
  Feature,
  FeatureIcon,
  FeatureList,
  FeatureText,
  OptionContainer,
  Options,
  PageContainer,
  PageDescription,
  PageHeader,
} from '../components/PageElements';

enum optionSelections {
  None = 0,
  Videos50 = 1,
  Videos200 = 2,
  Videos1k = 3,
}

export const ManageAnnotations = () => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = React.useState(
    optionSelections.None
  );

  const videos50 = (
    <>
      <label>
        <b>50&nbsp;{t('videos')}</b>
      </label>
      <label>$7{t('/mo')}</label>
      <Button
        text={
          selectedOption === optionSelections.Videos50
            ? t('Deactivate')
            : selectedOption === optionSelections.None
              ? t('Activate')
              : t('Downgrade')
        }
        variant={
          selectedOption === optionSelections.Videos50
            ? 'red'
            : selectedOption === optionSelections.None
              ? 'primary'
              : 'ghost'
        }
        onClick={() => {
          if (selectedOption === optionSelections.Videos50)
            setSelectedOption(optionSelections.None);
          else setSelectedOption(optionSelections.Videos50);
        }}
      />
    </>
  );

  const videos200 = (
    <>
      <label>
        <b>200&nbsp;{t('videos')}</b>
      </label>
      <label>$15{t('/mo')}</label>
      <Button
        text={
          selectedOption === optionSelections.None
            ? t('Activate')
            : selectedOption === optionSelections.Videos50
              ? t('Upgrade')
              : selectedOption == optionSelections.Videos200
                ? t('Deactivate')
                : t('Downgrade')
        }
        variant={
          selectedOption === optionSelections.Videos200
            ? 'red'
            : selectedOption == optionSelections.Videos1k
              ? 'ghost'
              : 'primary'
        }
        onClick={() => {
          if (selectedOption === optionSelections.Videos200)
            setSelectedOption(optionSelections.None);
          else setSelectedOption(optionSelections.Videos200);
        }}
      />
    </>
  );

  const videos1k = (
    <>
      <label>
        <b>1,000&nbsp;{t('videos')}</b>
      </label>
      <label>$60{t('/mo')}</label>
      <Button
        text={
          selectedOption === optionSelections.None
            ? t('Activate')
            : selectedOption === optionSelections.Videos50 ||
                selectedOption === optionSelections.Videos200
              ? t('Upgrade')
              : t('Deactivate')
        }
        variant={
          selectedOption === optionSelections.Videos1k ? 'red' : 'primary'
        }
        onClick={() => {
          if (selectedOption === optionSelections.Videos1k)
            setSelectedOption(optionSelections.None);
          else setSelectedOption(optionSelections.Videos1k);
        }}
      />
    </>
  );

  return (
    <PageContainer>
      <PageHeader>{t('Annotations')}</PageHeader>
      <PageDescription>
        {t(
          'Polish your videos by adding your contact info and company logo. Include hyperlinked CTAs like email me or schedule a call on sales videos to drive engagement and increase responses.'
        )}
      </PageDescription>
      <Options>
        {(selectedOption === optionSelections.Videos50 && (
          <ActiveOptionContainer>
            <ActiveHeader>{t('Active')}</ActiveHeader>
            {videos50}
          </ActiveOptionContainer>
        )) || <OptionContainer>{videos50}</OptionContainer>}
        {(selectedOption === optionSelections.Videos200 && (
          <ActiveOptionContainer>
            <ActiveHeader>{t('Active')}</ActiveHeader>
            {videos200}
          </ActiveOptionContainer>
        )) || <OptionContainer>{videos200}</OptionContainer>}
        {(selectedOption === optionSelections.Videos1k && (
          <ActiveOptionContainer>
            <ActiveHeader>{t('Active')}</ActiveHeader>
            {videos1k}
          </ActiveOptionContainer>
        )) || <OptionContainer>{videos1k}</OptionContainer>}
      </Options>
      <FeatureList>
        <Feature>
          <FeatureIcon>
            <MdDone fontSize='28px' />
          </FeatureIcon>
          <FeatureText>
            <label>
              {t(
                'Protect Privacy: Record, send and track messages from your personal device without using your personal phone number'
              )}
            </label>
          </FeatureText>
        </Feature>
        <Feature>
          <FeatureIcon>
            <MdDone fontSize='28px' />
          </FeatureIcon>
          <FeatureText>
            <label>
              {t(
                'Keep it Professional: Monitor team outreach and video statistics from your Covideo dashboard'
              )}
            </label>
          </FeatureText>
        </Feature>
        <Feature>
          <FeatureIcon>
            <MdDone fontSize='28px' />
          </FeatureIcon>
          <FeatureText>
            <label>
              {t(
                "Prevent Dropped Leads: Never miss out on leads or conversations, even if there's staff turnover"
              )}
            </label>
          </FeatureText>
        </Feature>
        <Feature>
          <FeatureIcon>
            <MdDone fontSize='28px' />
          </FeatureIcon>
          <FeatureText>
            <label>
              {t(
                'Comply with Policy: Centralize dealership communication and adhere to messaging compliance policies'
              )}
            </label>
          </FeatureText>
        </Feature>
      </FeatureList>
      <AddonFooter>
        {t(
          'Have a question? Contact your account manager, contact us at support@covideo.com or give us a call at 1.800.306.1445.'
        )}
      </AddonFooter>
    </PageContainer>
  );
};
